import { createApp, reactive } from "vue";
import { createPinia } from "pinia";
import { auth } from "@/firebase";
import { onAuthStateChanged } from "firebase/auth";

import App from "./App.vue";
import { currentAppInstancePlugin } from "./plugins/currentAppInstance";
import router from "./router/index";
import rollbar from "./rollbar";
import VIcon from '@/components/GlobalComponents/VIcon.vue'

import VClipboard from "./directives/VClipboard.js";

import "./vue-awesome-icons.js";
import "./assets/setupStyle.css";
import "./assets/style.css";

const pinia = createPinia();

// app.config.errorHandler = (err, vm) => {
//   vm.$rollbar.error(err);
//   throw err; // rethrow
// };

let app;

onAuthStateChanged(auth, (user) => {
  rollbar.configure({
    payload: user ? { person: { id: user.uid } } : {},
  });

  if (!app) {
    app = createApp(App);
    app.component("VIcon", VIcon);
    app.use(VClipboard);
    app.use(router);
    app.use(pinia);
    app.use(currentAppInstancePlugin)

    app.provide('toastEvents', reactive([]));
    app.config.globalProperties.$rollbar = rollbar;

    app.mount("#app")
  }
});
